export default {
  methods: {
    checkUserRole (userRole, checkRoles) {
      return _.includes(checkRoles, userRole)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/mixins/CheckUserRole.js